export default __webpack_public_path__ + "static/media/company.6a874d34.svg";